// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: iKm2w5zQkVZvuqT51PP4Eo
// Component: pcQ3qiQYH3R

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import TextInput from "../../TextInput"; // plasmic-import: LW1ZHmZtc1I/component
import GenerateButton from "../../GenerateButton"; // plasmic-import: Fs5OtDdX5n/component
import AdTemplate1 from "../../AdTemplate1"; // plasmic-import: mz5eL8luPc/component
import GenericButton from "../../GenericButton"; // plasmic-import: rRlSjYLvCT/component
import { AntdTextArea } from "@plasmicpkgs/antd5/skinny/registerInput"; // plasmic-import: pTzGlMptTxd/codeComponent
import { inputHelpers as AntdTextArea_Helpers } from "@plasmicpkgs/antd5/skinny/registerInput"; // plasmic-import: pTzGlMptTxd/codeComponentHelper

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_idea_stats_v_1.module.css"; // plasmic-import: iKm2w5zQkVZvuqT51PP4Eo/projectcss
import sty from "./PlasmicAdPromptSelected.module.css"; // plasmic-import: pcQ3qiQYH3R/css

import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: SvpL0X2s9gW/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: SBvHu7dbLxB/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: UVhfm8Vw8/icon
import Icon2Icon from "./icons/PlasmicIcon__Icon2"; // plasmic-import: BINpeFFuv2/icon

export type PlasmicAdPromptSelected__VariantMembers = {};
export type PlasmicAdPromptSelected__VariantsArgs = {};
type VariantPropType = keyof PlasmicAdPromptSelected__VariantsArgs;
export const PlasmicAdPromptSelected__VariantProps =
  new Array<VariantPropType>();

export type PlasmicAdPromptSelected__ArgsType = {};
type ArgPropType = keyof PlasmicAdPromptSelected__ArgsType;
export const PlasmicAdPromptSelected__ArgProps = new Array<ArgPropType>();

export type PlasmicAdPromptSelected__OverridesType = {
  root?: p.Flex<"div">;
  h1?: p.Flex<"h1">;
  columns?: p.Flex<"div">;
  textInput?: p.Flex<typeof TextInput>;
  generateButton?: p.Flex<typeof GenerateButton>;
  adTemplate1?: p.Flex<typeof AdTemplate1>;
  resetButton?: p.Flex<typeof GenericButton>;
  selectButton?: p.Flex<typeof GenericButton>;
  componentList?: p.Flex<"div">;
  changeTitle?: p.Flex<"div">;
  collapseAble1?: p.Flex<typeof GenericButton>;
  titleInput?: p.Flex<typeof TextInput>;
  changeBody?: p.Flex<"div">;
  collapseAble?: p.Flex<typeof GenericButton>;
  bodyArea?: p.Flex<typeof AntdTextArea>;
  changeButton?: p.Flex<"div">;
  collapseAble13?: p.Flex<typeof GenericButton>;
  buttonIntput?: p.Flex<typeof TextInput>;
  changeImage?: p.Flex<"div">;
  collapseAble12?: p.Flex<typeof GenericButton>;
  generateImgInput?: p.Flex<typeof TextInput>;
  getImgButton?: p.Flex<typeof GenericButton>;
  changeDestination?: p.Flex<"div">;
  collapseAble2?: p.Flex<typeof GenericButton>;
  destinationLinkInput?: p.Flex<typeof TextInput>;
};

export interface DefaultAdPromptSelectedProps {
  className?: string;
}

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn());
const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    return await promise;
  });

function PlasmicAdPromptSelected__RenderFunc(props: {
  variants: PlasmicAdPromptSelected__VariantsArgs;
  args: PlasmicAdPromptSelected__ArgsType;
  overrides: PlasmicAdPromptSelected__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const [$queries, setDollarQueries] = React.useState({});

  const stateSpecs = React.useMemo(
    () => [
      {
        path: "textInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "" as const
      },
      {
        path: "titleInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "" as const
      },
      {
        path: "bodyArea.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "generateImgInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "" as const
      },
      {
        path: "destinationLinkInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "" as const
      },
      {
        path: "buttonIntput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "" as const
      }
    ],
    [$props, $ctx]
  );
  const $state = p.useDollarState(stateSpecs, { $props, $ctx, $queries });

  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          {true ? (
            <div className={classNames(projectcss.all, sty.freeBox__nxAzr)}>
              <h1
                data-plasmic-name={"h1"}
                data-plasmic-override={overrides.h1}
                className={classNames(
                  projectcss.all,
                  projectcss.h1,
                  projectcss.__wab_text,
                  sty.h1
                )}
              >
                {"Customize Your Template"}
              </h1>
              <div
                data-plasmic-name={"columns"}
                data-plasmic-override={overrides.columns}
                className={classNames(projectcss.all, sty.columns)}
              >
                <div className={classNames(projectcss.all, sty.column__n05XM)}>
                  {true ? (
                    <div
                      className={classNames(projectcss.all, sty.freeBox__ieCwN)}
                    >
                      {true ? (
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__nwm7Z
                          )}
                        >
                          {true ? (
                            <div
                              className={classNames(
                                projectcss.all,
                                sty.freeBox__t1SZx
                              )}
                            >
                              <TextInput
                                data-plasmic-name={"textInput"}
                                data-plasmic-override={overrides.textInput}
                                className={classNames(
                                  "__wab_instance",
                                  sty.textInput
                                )}
                                onChange={(...eventArgs) => {
                                  p.generateStateOnChangeProp($state, [
                                    "textInput",
                                    "value"
                                  ])(
                                    (e => e.target?.value).apply(
                                      null,
                                      eventArgs
                                    )
                                  );
                                }}
                                startIcon={
                                  <SearchsvgIcon
                                    className={classNames(
                                      projectcss.all,
                                      sty.svg___8BiLq
                                    )}
                                    role={"img"}
                                  />
                                }
                                value={
                                  p.generateStateValueProp($state, [
                                    "textInput",
                                    "value"
                                  ]) ?? ""
                                }
                              />

                              <GenerateButton
                                data-plasmic-name={"generateButton"}
                                data-plasmic-override={overrides.generateButton}
                                className={classNames(
                                  "__wab_instance",
                                  sty.generateButton
                                )}
                              />
                            </div>
                          ) : null}
                          <AdTemplate1
                            data-plasmic-name={"adTemplate1"}
                            data-plasmic-override={overrides.adTemplate1}
                            body={
                              <div
                                className={classNames(
                                  projectcss.all,
                                  projectcss.__wab_text,
                                  sty.text__edznr
                                )}
                              >
                                {
                                  "Ad body. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                                }
                              </div>
                            }
                            className={classNames(
                              "__wab_instance",
                              sty.adTemplate1
                            )}
                          />

                          {true ? (
                            <div
                              className={classNames(
                                projectcss.all,
                                sty.freeBox__g8XkX
                              )}
                            >
                              <GenericButton
                                data-plasmic-name={"resetButton"}
                                data-plasmic-override={overrides.resetButton}
                                className={classNames(
                                  "__wab_instance",
                                  sty.resetButton
                                )}
                              >
                                <IconIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__bbSec
                                  )}
                                  role={"img"}
                                />
                              </GenericButton>
                              <GenericButton
                                data-plasmic-name={"selectButton"}
                                data-plasmic-override={overrides.selectButton}
                                className={classNames(
                                  "__wab_instance",
                                  sty.selectButton
                                )}
                              >
                                {"Select"}
                              </GenericButton>
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
                <div className={classNames(projectcss.all, sty.column__r2LNa)}>
                  <div
                    data-plasmic-name={"componentList"}
                    data-plasmic-override={overrides.componentList}
                    className={classNames(projectcss.all, sty.componentList)}
                  >
                    {true ? (
                      <div
                        data-plasmic-name={"changeTitle"}
                        data-plasmic-override={overrides.changeTitle}
                        className={classNames(projectcss.all, sty.changeTitle)}
                      >
                        <GenericButton
                          data-plasmic-name={"collapseAble1"}
                          data-plasmic-override={overrides.collapseAble1}
                          className={classNames(
                            "__wab_instance",
                            sty.collapseAble1
                          )}
                        >
                          <Icon2Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__ze4KL
                            )}
                            role={"img"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__zMubc
                            )}
                          >
                            {"Change Title"}
                          </div>
                        </GenericButton>
                        <TextInput
                          data-plasmic-name={"titleInput"}
                          data-plasmic-override={overrides.titleInput}
                          className={classNames(
                            "__wab_instance",
                            sty.titleInput
                          )}
                          onChange={(...eventArgs) => {
                            p.generateStateOnChangeProp($state, [
                              "titleInput",
                              "value"
                            ])((e => e.target?.value).apply(null, eventArgs));
                          }}
                          value={
                            p.generateStateValueProp($state, [
                              "titleInput",
                              "value"
                            ]) ?? ""
                          }
                        />
                      </div>
                    ) : null}
                    {true ? (
                      <div
                        data-plasmic-name={"changeBody"}
                        data-plasmic-override={overrides.changeBody}
                        className={classNames(projectcss.all, sty.changeBody)}
                      >
                        <GenericButton
                          data-plasmic-name={"collapseAble"}
                          data-plasmic-override={overrides.collapseAble}
                          className={classNames(
                            "__wab_instance",
                            sty.collapseAble
                          )}
                        >
                          <Icon2Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__bkbl5
                            )}
                            role={"img"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__qhdQw
                            )}
                          >
                            {"Change Body"}
                          </div>
                        </GenericButton>
                        {(() => {
                          const child$Props = {
                            className: classNames(
                              "__wab_instance",
                              sty.bodyArea
                            ),
                            onChange:
                              p.generateStateOnChangePropForCodeComponents(
                                $state,
                                "value",
                                ["bodyArea", "value"],
                                AntdTextArea_Helpers
                              ),
                            value: p.generateStateValueProp($state, [
                              "bodyArea",
                              "value"
                            ])
                          };
                          p.initializeCodeComponentStates(
                            $state,
                            [
                              {
                                name: "value",
                                plasmicStateName: "bodyArea.value"
                              }
                            ],
                            [],
                            AntdTextArea_Helpers ?? {},
                            child$Props
                          );

                          return (
                            <AntdTextArea
                              data-plasmic-name={"bodyArea"}
                              data-plasmic-override={overrides.bodyArea}
                              {...child$Props}
                            />
                          );
                        })()}
                      </div>
                    ) : null}
                    {true ? (
                      <div
                        data-plasmic-name={"changeButton"}
                        data-plasmic-override={overrides.changeButton}
                        className={classNames(projectcss.all, sty.changeButton)}
                      >
                        <GenericButton
                          data-plasmic-name={"collapseAble13"}
                          data-plasmic-override={overrides.collapseAble13}
                          className={classNames(
                            "__wab_instance",
                            sty.collapseAble13
                          )}
                        >
                          <Icon2Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__zjnWo
                            )}
                            role={"img"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__gVoOz
                            )}
                          >
                            {"Change Button"}
                          </div>
                        </GenericButton>
                        <TextInput
                          data-plasmic-name={"buttonIntput"}
                          data-plasmic-override={overrides.buttonIntput}
                          className={classNames(
                            "__wab_instance",
                            sty.buttonIntput
                          )}
                          onChange={(...eventArgs) => {
                            p.generateStateOnChangeProp($state, [
                              "buttonIntput",
                              "value"
                            ])((e => e.target?.value).apply(null, eventArgs));
                          }}
                          value={
                            p.generateStateValueProp($state, [
                              "buttonIntput",
                              "value"
                            ]) ?? ""
                          }
                        />
                      </div>
                    ) : null}
                    {true ? (
                      <div
                        data-plasmic-name={"changeImage"}
                        data-plasmic-override={overrides.changeImage}
                        className={classNames(projectcss.all, sty.changeImage)}
                      >
                        <GenericButton
                          data-plasmic-name={"collapseAble12"}
                          data-plasmic-override={overrides.collapseAble12}
                          className={classNames(
                            "__wab_instance",
                            sty.collapseAble12
                          )}
                        >
                          <Icon2Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__oxXll
                            )}
                            role={"img"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__xfsae
                            )}
                          >
                            {"Change Image"}
                          </div>
                        </GenericButton>
                        {true ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox___1K5Rv
                            )}
                          >
                            <TextInput
                              data-plasmic-name={"generateImgInput"}
                              data-plasmic-override={overrides.generateImgInput}
                              className={classNames(
                                "__wab_instance",
                                sty.generateImgInput
                              )}
                              onChange={(...eventArgs) => {
                                p.generateStateOnChangeProp($state, [
                                  "generateImgInput",
                                  "value"
                                ])(
                                  (e => e.target?.value).apply(null, eventArgs)
                                );
                              }}
                              value={
                                p.generateStateValueProp($state, [
                                  "generateImgInput",
                                  "value"
                                ]) ?? ""
                              }
                            />

                            <GenericButton
                              data-plasmic-name={"getImgButton"}
                              data-plasmic-override={overrides.getImgButton}
                              className={classNames(
                                "__wab_instance",
                                sty.getImgButton
                              )}
                            >
                              {"->"}
                            </GenericButton>
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                    {true ? (
                      <div
                        data-plasmic-name={"changeDestination"}
                        data-plasmic-override={overrides.changeDestination}
                        className={classNames(
                          projectcss.all,
                          sty.changeDestination
                        )}
                      >
                        <GenericButton
                          data-plasmic-name={"collapseAble2"}
                          data-plasmic-override={overrides.collapseAble2}
                          className={classNames(
                            "__wab_instance",
                            sty.collapseAble2
                          )}
                        >
                          <Icon2Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__rFbie
                            )}
                            role={"img"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__zjlh5
                            )}
                          >
                            {"Destination Link"}
                          </div>
                        </GenericButton>
                        <TextInput
                          data-plasmic-name={"destinationLinkInput"}
                          data-plasmic-override={overrides.destinationLinkInput}
                          className={classNames(
                            "__wab_instance",
                            sty.destinationLinkInput
                          )}
                          onChange={(...eventArgs) => {
                            p.generateStateOnChangeProp($state, [
                              "destinationLinkInput",
                              "value"
                            ])((e => e.target?.value).apply(null, eventArgs));
                          }}
                          value={
                            p.generateStateValueProp($state, [
                              "destinationLinkInput",
                              "value"
                            ]) ?? ""
                          }
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "h1",
    "columns",
    "textInput",
    "generateButton",
    "adTemplate1",
    "resetButton",
    "selectButton",
    "componentList",
    "changeTitle",
    "collapseAble1",
    "titleInput",
    "changeBody",
    "collapseAble",
    "bodyArea",
    "changeButton",
    "collapseAble13",
    "buttonIntput",
    "changeImage",
    "collapseAble12",
    "generateImgInput",
    "getImgButton",
    "changeDestination",
    "collapseAble2",
    "destinationLinkInput"
  ],
  h1: ["h1"],
  columns: [
    "columns",
    "textInput",
    "generateButton",
    "adTemplate1",
    "resetButton",
    "selectButton",
    "componentList",
    "changeTitle",
    "collapseAble1",
    "titleInput",
    "changeBody",
    "collapseAble",
    "bodyArea",
    "changeButton",
    "collapseAble13",
    "buttonIntput",
    "changeImage",
    "collapseAble12",
    "generateImgInput",
    "getImgButton",
    "changeDestination",
    "collapseAble2",
    "destinationLinkInput"
  ],
  textInput: ["textInput"],
  generateButton: ["generateButton"],
  adTemplate1: ["adTemplate1"],
  resetButton: ["resetButton"],
  selectButton: ["selectButton"],
  componentList: [
    "componentList",
    "changeTitle",
    "collapseAble1",
    "titleInput",
    "changeBody",
    "collapseAble",
    "bodyArea",
    "changeButton",
    "collapseAble13",
    "buttonIntput",
    "changeImage",
    "collapseAble12",
    "generateImgInput",
    "getImgButton",
    "changeDestination",
    "collapseAble2",
    "destinationLinkInput"
  ],
  changeTitle: ["changeTitle", "collapseAble1", "titleInput"],
  collapseAble1: ["collapseAble1"],
  titleInput: ["titleInput"],
  changeBody: ["changeBody", "collapseAble", "bodyArea"],
  collapseAble: ["collapseAble"],
  bodyArea: ["bodyArea"],
  changeButton: ["changeButton", "collapseAble13", "buttonIntput"],
  collapseAble13: ["collapseAble13"],
  buttonIntput: ["buttonIntput"],
  changeImage: [
    "changeImage",
    "collapseAble12",
    "generateImgInput",
    "getImgButton"
  ],
  collapseAble12: ["collapseAble12"],
  generateImgInput: ["generateImgInput"],
  getImgButton: ["getImgButton"],
  changeDestination: [
    "changeDestination",
    "collapseAble2",
    "destinationLinkInput"
  ],
  collapseAble2: ["collapseAble2"],
  destinationLinkInput: ["destinationLinkInput"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  h1: "h1";
  columns: "div";
  textInput: typeof TextInput;
  generateButton: typeof GenerateButton;
  adTemplate1: typeof AdTemplate1;
  resetButton: typeof GenericButton;
  selectButton: typeof GenericButton;
  componentList: "div";
  changeTitle: "div";
  collapseAble1: typeof GenericButton;
  titleInput: typeof TextInput;
  changeBody: "div";
  collapseAble: typeof GenericButton;
  bodyArea: typeof AntdTextArea;
  changeButton: "div";
  collapseAble13: typeof GenericButton;
  buttonIntput: typeof TextInput;
  changeImage: "div";
  collapseAble12: typeof GenericButton;
  generateImgInput: typeof TextInput;
  getImgButton: typeof GenericButton;
  changeDestination: "div";
  collapseAble2: typeof GenericButton;
  destinationLinkInput: typeof TextInput;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAdPromptSelected__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicAdPromptSelected__VariantsArgs;
    args?: PlasmicAdPromptSelected__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicAdPromptSelected__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicAdPromptSelected__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicAdPromptSelected__ArgProps,
          internalVariantPropNames: PlasmicAdPromptSelected__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAdPromptSelected__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAdPromptSelected";
  } else {
    func.displayName = `PlasmicAdPromptSelected.${nodeName}`;
  }
  return func;
}

export const PlasmicAdPromptSelected = Object.assign(
  // Top-level PlasmicAdPromptSelected renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    h1: makeNodeComponent("h1"),
    columns: makeNodeComponent("columns"),
    textInput: makeNodeComponent("textInput"),
    generateButton: makeNodeComponent("generateButton"),
    adTemplate1: makeNodeComponent("adTemplate1"),
    resetButton: makeNodeComponent("resetButton"),
    selectButton: makeNodeComponent("selectButton"),
    componentList: makeNodeComponent("componentList"),
    changeTitle: makeNodeComponent("changeTitle"),
    collapseAble1: makeNodeComponent("collapseAble1"),
    titleInput: makeNodeComponent("titleInput"),
    changeBody: makeNodeComponent("changeBody"),
    collapseAble: makeNodeComponent("collapseAble"),
    bodyArea: makeNodeComponent("bodyArea"),
    changeButton: makeNodeComponent("changeButton"),
    collapseAble13: makeNodeComponent("collapseAble13"),
    buttonIntput: makeNodeComponent("buttonIntput"),
    changeImage: makeNodeComponent("changeImage"),
    collapseAble12: makeNodeComponent("collapseAble12"),
    generateImgInput: makeNodeComponent("generateImgInput"),
    getImgButton: makeNodeComponent("getImgButton"),
    changeDestination: makeNodeComponent("changeDestination"),
    collapseAble2: makeNodeComponent("collapseAble2"),
    destinationLinkInput: makeNodeComponent("destinationLinkInput"),

    // Metadata about props expected for PlasmicAdPromptSelected
    internalVariantProps: PlasmicAdPromptSelected__VariantProps,
    internalArgProps: PlasmicAdPromptSelected__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicAdPromptSelected;
/* prettier-ignore-end */
